<script lang="ts" setup>
import {
  TuiInputGroup,
  TuiSwitchButtonGroup,
  TuiTextInput,
  TuiTopLabelLayout,
} from '@clickbar/tailwindui-vue'

import type { PageElementDataOfType } from '../page-builder'
import type { StrictRouteName } from '@/app/route'

const data = defineModel<PageElementDataOfType<'linkButton'>>('data', {
  required: true,
})

watchEffect(() => {
  if (!data.value.color) {
    data.value.color = 'primary'
  }
})

const availableInternalRoutes: { value: StrictRouteName; text: string }[] = [
  { value: 'tenant.faq.index', text: 'Häufig gestellte Fragen' },
  { value: 'tenant.contact.index', text: 'Kontakt' },
  { value: 'tenant.home', text: 'Übersicht' },
  { value: 'tenant.products.index', text: 'Produkte' },
]

const availableColors = [
  { value: 'primary', text: 'Primär' },
  { value: 'accent', text: 'Akzent' },
  { value: 'white', text: 'Neutral' },
] satisfies { value: string; text: string }[]

const targetType = computed({
  get() {
    return data.value.target.type
  },
  set(type: PageElementDataOfType<'linkButton'>['target']['type']) {
    // eslint-disable-next-line unicorn/prefer-ternary
    if (type === 'internal') {
      data.value.target = {
        type,
        route: null,
      }
    } else {
      data.value.target = {
        type,
        url: '',
      }
    }
  },
})
</script>

<template>
  <div class="grid grid-cols-[repeat(auto-fill,minmax(min(20rem,100%),1fr))] gap-2">
    <TuiTopLabelLayout label="Beschriftung">
      <TuiTextInput v-model="data.label" placeholder="Beschriftung eingeben" />
    </TuiTopLabelLayout>

    <TuiTopLabelLayout label="Ziel">
      <TuiInputGroup class="flex">
        <TuiSwitchButtonGroup v-model="targetType" class="!rounded-r-none shadow-sm">
          <TuiSwitchButton value="internal" label="Intern" />

          <TuiSwitchButton value="external" label="Extern" />
        </TuiSwitchButtonGroup>

        <div class="w-1 bg-zinc-100" />

        <template v-if="data.target.type === 'internal'">
          <TuiSelect
            v-model="data.target.route"
            :options="availableInternalRoutes"
            wrapper-classes="flex-1"
            placeholder="Seite wählen"
            fixed
          />
        </template>

        <template v-if="data.target.type === 'external'">
          <TuiTextInput
            v-model="data.target.url"
            type="url"
            container-class="flex-1"
            placeholder="URL eingeben"
          />
        </template>
      </TuiInputGroup>
    </TuiTopLabelLayout>

    <TuiTopLabelLayout label="Theme">
      <div class="grid grid-cols-2 gap-2">
        <TuiSelect
          v-model="data.color"
          fixed
          :options="availableColors"
          placeholder="Farbe wählen"
        />

        <div class="flex items-center justify-between bg-white rounded border border-zinc-300 px-2">
          <p class="text-sm">Sekundär</p>

          <TuiSwitch v-model="data.secondary" />
        </div>
      </div>
    </TuiTopLabelLayout>
  </div>
</template>
